export const getStageSessions = (sessions, stageSlug) => {
  let currentSession
  let nextSession
  sessions.forEach((session) => {
    if (session.data.Stage && session.data.Stage[0] && session.data.Stage[0].data.Stage_Slug === stageSlug) {
      if (
        new Date(session.data.UTC_Start_Time).getTime() < Date.now() &&
        new Date(session.data.UTC_End_Time).getTime() > Date.now()
      )
        currentSession = session
      if (
        new Date(session.data.UTC_Start_Time).getTime() > Date.now() &&
        nextSession &&
        new Date(session.data.UTC_Start_Time).getTime() < new Date(nextSession.data.UTC_Start_Time).getTime()
      )
        nextSession = session
      if (new Date(session.data.UTC_Start_Time).getTime() > Date.now() && !nextSession) nextSession = session
    }
  })

  return {
    currentSession,
    nextSession,
  }
}
export const getCurrentStageDay = (stageDays, stageSlug) => {
  let active, next
  stageDays.forEach((stageDay) => {
    if (
      stageDay.data.Stage &&
      stageDay.data.Stage[0] &&
      stageDay.data.Stage[0].data.Stage_Slug === stageSlug
    ) {
      if (
        new Date(stageDay.data.UTC_Start_Time).getTime() < Date.now() &&
        new Date(stageDay.data.UTC_End_Time).getTime() + lateEnd > Date.now()
      )
        active = stageDay
      if (
        new Date(stageDay.data.UTC_Start_Time).getTime() > Date.now() &&
        (!next ||
          new Date(stageDay.data.UTC_Start_Time).getTime() < new Date(next.data.UTC_Start_Time).getTime())
      )
        next = stageDay
    }
  })

  return active || next
}

export const earlyStart = 1000 * 60 * 60 * 24 // show the countdown 24 hours early
export const lateEnd = 1000 * 60 * 60 // end after 1 hour to give time for overrun
export const lateClose = 1000 * 60 * 60 * 24 * 3 // close after 3 days

// export const calculateConferenceStatus = (stageDays) => {
//   if (!stageDays) return {}
//   if (typeof stageDays === 'object' && stageDays.nodes) stageDays = stageDays.nodes
//   let earliestStageDay
//   let latestStageDay
//   stageDays.forEach((stageDay) => {
//     if (!earliestStageDay || new Date(stageDay.data.UTC_Start_Time).getTime() < new Date(earliestStageDay.data.UTC_Start_Time).getTime()) earliestStageDay = stageDay
//     if (!latestStageDay || new Date(stageDay.data.UTC_End_Time).getTime() > new Date(latestStageDay.data.UTC_End_Time).getTime()) latestStageDay = stageDay
//   })

//   const status = {
//     started: false,
//     ended: false
//   }
//   if (earliestStageDay) {
//     if (Date.now() > (new Date(latestStageDay.data.UTC_End_Time).getTime() + lateEnd)) status.ended = true
//     if (Date.now() > (new Date(latestStageDay.data.UTC_End_Time).getTime() + lateClose)) status.close = true
//     if (Date.now() > (new Date(earliestStageDay.data.UTC_Start_Time) - earlyStart)) status.started = true
//   }
//   return status
// }

export const calculateConferenceStatus = (sessions) => {
  if (!sessions) return {}
  if (typeof sessions === 'object' && sessions.nodes) sessions = sessions.nodes

  const liveSessions = sessions
    .filter((session) => {
      return (
        session.data.Session_Status === 'Published' &&
        session.data.Session_Groups?.[0]?.data?.Delivery === 'Live'
      )
    })
    .sort((a, b) => {
      return new Date(a.data.UTC_Start_Time).getTime() - new Date(b.data.UTC_Start_Time).getTime()
    })
  const earliestSession = liveSessions[0]
  const latestSession = liveSessions[liveSessions.length - 1]

  const status = {
    early: false,
    started: false,
    ended: false,
    close: false,
  }
  if (earliestSession) {
    if (
      latestSession.data.UTC_End_Time &&
      Date.now() > new Date(latestSession.data.UTC_End_Time).getTime() + lateEnd
    )
      status.ended = true
    if (
      latestSession.data.UTC_End_Time &&
      Date.now() > new Date(latestSession.data.UTC_End_Time).getTime() + lateClose
    )
      status.close = true
    if (earliestSession.data.UTC_Start_Time && Date.now() > new Date(earliestSession.data.UTC_Start_Time))
      status.started = true
    if (
      earliestSession.data.UTC_Start_Time &&
      Date.now() > new Date(earliestSession.data.UTC_Start_Time) - earlyStart
    )
      status.early = true
  }
  return status
}

export const getCurrentStageSessions = (sessions, stages) => {
  const currentSessionStages = {}
  stages.forEach((stage) => {
    currentSessionStages[stage.data.Stage_Slug] = getStageSessions(sessions, stage.data.Stage_Slug)
  })
  return currentSessionStages
}
